module.exports = __webpack_public_path__ + "img/mpcode.e415d41f.png";